import React from "react";

import { Popover, Transition } from '@headlessui/react'

import {
  InformationCircleIcon
} from '@heroicons/react/outline';

// shows search formats
const AudienceSearchFormat = ({}) => {
  
  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <Popover.Button
            className={`mt-2 mr-2 p-1 text-xs text-white border hover:bg-gray-800 border-gray-700 cursor-pointer rounded-md flex items-center focus:outline-none focus:ring-transparent focus:border-none`}
            // className={`flex-shrink-0 inline-flex p-2 items-center justify-center focus:outline-none focus:ring-transparent focus:border-none rounded-lg ${open ? 'bg-gray-900 text-white' : 'text-gray-400 hover:bg-gray-700'}`}
          >
          <InformationCircleIcon className="h-4 w-4 mr-1 opacity-25" aria-hidden="true" />
            <span>Search Tips</span>
          </Popover.Button>

          <Transition
            show={open}
            as={React.Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
          <Popover.Panel
            static
            className="absolute z-10 bg-white text-gray-900 shadow-lg rounded-lg left-0 top-full p-2 w-screen max-w-xs sm:max-w-md"
          >
            <div className="text-sm p-2">
            <div className="mb-2 font-semibold">
                Read the <a className="underline" href="https://gummysearch.com/insights/keywords-to-track-on-reddit/" target="_blank">
                keyword guide
            </a> for useful words to search/track</div>

            <label className="opacity-50 text-xs font-bold">Standard fuzzy search</label>
            <div className="mb-1">Reddit Marketing</div>

            <label className="opacity-50 text-xs font-bold">Quotes ensure exact match</label>
            <div className="mb-1">"Reddit is"</div>

            <label className="opacity-50 text-xs font-bold">Either keyword</label>
            <div className="mb-1">"customer development" OR "audience research"</div>

            <label className="opacity-50 text-xs font-bold">Both keywords</label>
            <div className="mb-1">"customer development" AND "audience research"</div>

            <label className="opacity-50 text-xs font-bold">Complex AND/OR</label>
            <div className="mb-1">customer AND (research OR development)</div>

            <label className="opacity-50 text-xs font-bold">Exclude keyword</label>
            <div className="mb-1">customer AND NOT research</div>

            <label className="opacity-50 text-xs font-bold">Search title only</label>
            <div className="mb-1">title:reddit</div>

            <label className="opacity-50 text-xs font-bold">Search title with OR statement</label>
            <div className="mb-1">title:reddit OR title:twitter</div>

            
            </div>
          </Popover.Panel>
        </Transition>
        </>
      )}
    </Popover>
  )
}

export default AudienceSearchFormat;

